import { Component, type ErrorInfo, type ReactNode } from "react";

interface RouteErrorBoundaryProps {
  children: ReactNode;
}

interface RouteErrorBoundaryState {
  failed: boolean;
}

export class RouteErrorBoundary extends Component<
  RouteErrorBoundaryProps,
  RouteErrorBoundaryState
> {
  override state: RouteErrorBoundaryState = { failed: false };

  static getDerivedStateFromError(): RouteErrorBoundaryState {
    return { failed: true };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Route bundle failed to load", error, info.componentStack);
  }

  override render() {
    if (!this.state.failed) return this.props.children;

    return (
      <main className="route-error" role="alert">
        <span className="eyebrow">Version recovery</span>
        <h1>内容包已更新</h1>
        <p>当前页面仍在使用旧版场景资源。刷新后即可继续，已完成的学习记录不会丢失。</p>
        <button className="primary-button" type="button" onClick={() => window.location.reload()}>
          刷新并继续 <b aria-hidden="true">→</b>
        </button>
      </main>
    );
  }
}
